var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.35 3.65001H9.46998L8.02998 2.25001L3.14996 2.25001C2.35796 2.25001 1.70996 2.88001 1.70996 3.65001L1.70996 12.45C1.70996 13.22 2.35796 13.85 3.14996 13.85L14.35 13.85C15.142 13.85 15.79 13.22 15.79 12.45V5.05001C15.79 4.28001 15.142 3.65001 14.35 3.65001ZM14.35 12.45L3.14996 12.45V3.65001L7.45398 3.65001L8.89398 5.05001H14.35V12.45ZM13.23 11.45L10.35 7.85001L7.95 10.65L5.95 8.65001L3.95 11.45H13.23ZM7.30998 6.50001C7.30998 5.94001 6.80598 5.45001 6.22998 5.45001C5.65398 5.45001 5.14998 5.94001 5.14998 6.50001C5.14998 7.06001 5.65398 7.55001 6.22998 7.55001C6.80598 7.55001 7.30998 7.06001 7.30998 6.50001Z",
    fill: "#2E3438"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedia);
export default __webpack_public_path__ + "static/media/media.7f0f78b22f958d4d019486f747759025.svg";
export { ForwardRef as ReactComponent };